export const escapeHtml = (text: string) =>
  text
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;");

export const printWDUserAgreement = (header: string, content: string) => {
  const printWindow = window.open("", "_blank");
  if (!printWindow) return;

  const title = escapeHtml(header);

  const paragraphs = content
    .split("\n")
    .map((paragraph) => `<p>${escapeHtml(paragraph)}</p>`)
    .join("");

  printWindow.document.write(`<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>${title}</title>
    <style>
      body {
        font-family: system-ui, -apple-system, sans-serif;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.5;
        padding: 0.75in;
        color: #000;
      }
      h1 {
        font-size: 1.125rem;
        font-weight: 600;
        margin: 0 0 1.5rem;
      }
      p {
        margin: 0 0 1.5rem;
        text-align: left;
      }
      p:last-child {
        margin-bottom: 0;
      }
    </style>
  </head>
  <body>
    <h1>${title}</h1>
    ${paragraphs}
  </body>
</html>`);
  printWindow.document.close();
  printWindow.focus();
  printWindow.onafterprint = () => printWindow.close();
  // Allow the new document to layout before opening the print dialog
  setTimeout(() => printWindow.print(), 0);
};
